function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.46 41.696L19.947 5.12v-.003h8.107v.002L41.54 41.696l.46 1.25H34.8l-3.985-10.808h-13.63L13.2 42.946H6l.46-1.25zM27.182 6.367H20.82L7.793 41.697h4.535l3.684-9.992.301-.817h15.374l.301.817 3.684 9.991h4.535L27.18 6.367zm-2.505 5.505h-1.352l-.497 1.348-4.325 11.73-.62 1.683H30.118l-.62-1.683-4.325-11.73-.497-1.348zm-1.342 3.588L24 13.653l.666 1.806 3.198 8.674.46 1.25H19.676l.461-1.25 3.198-8.673z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.5,
  cy: 5.5,
  r: 0.875,
  fill: "#fff",
  stroke: "currentColor",
  strokeWidth: 1.25
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 42.5,
  r: 0.875,
  fill: "#fff",
  stroke: "currentColor",
  strokeWidth: 1.25
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 42.5,
  r: 0.875,
  fill: "#fff",
  stroke: "currentColor",
  strokeWidth: 1.25
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 42.5,
  r: 0.875,
  fill: "#fff",
  stroke: "currentColor",
  strokeWidth: 1.25
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 42.5,
  r: 0.875,
  fill: "#fff",
  stroke: "currentColor",
  strokeWidth: 1.25
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 31.5,
  r: 0.875,
  fill: "#fff",
  stroke: "currentColor",
  strokeWidth: 1.25
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 31.5,
  r: 0.875,
  fill: "#fff",
  stroke: "currentColor",
  strokeWidth: 1.25
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 26,
  r: 0.875,
  fill: "#fff",
  stroke: "currentColor",
  strokeWidth: 1.25
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 26,
  r: 0.875,
  fill: "#fff",
  stroke: "currentColor",
  strokeWidth: 1.25
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 12.5,
  r: 0.875,
  fill: "#fff",
  stroke: "currentColor",
  strokeWidth: 1.25
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.5,
  cy: 5.5,
  r: 0.875,
  fill: "#fff",
  stroke: "currentColor",
  strokeWidth: 1.25
});

var SvgFont = function SvgFont(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

export default "data:image/svg+xml;base64,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";
export { SvgFont as ReactComponent };